import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators';

import { TopicSearchResult } from '../../types';
import { getTopicsforBackpack } from '../../helpers/api/topics-api';

@customElement('view-creator-profiles-page')
export class ViewCreatorProfilesPage extends LitElement {
    amplitude_callsite: string = 'View Creator Profiles Page';

    @state()
    topics: TopicSearchResult[] = [];

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        this.topics = await getTopicsforBackpack(this.amplitude_callsite);

        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    private onUpdateFilterType(e: any) {
        window.location.assign(e.detail.filterTypeInfo.url);
    }

    render() {
        return html`
            <nav-bar type="folder"></nav-bar>
            <div class="pageContainer">
                <backpack-sidebar
                    .topics=${this.topics}
                    .showFolders=${false}
                    @on-select-filter-type=${this.onUpdateFilterType}>
                </backpack-sidebar>
            </div>
            <div class="bottomTabs">
                <a class="tabItem" href="#folder">
                    <mwc-icon>folder</mwc-icon>
                    <div>Folders</div>
                </a>
                <a class="tabItem" href="#home">
                    <mwc-icon>home</mwc-icon>
                    <div>Backpack</div>
                </a>
                <a class="tabItem active" href="#edit-creator-profile">
                    <mwc-icon>account_circle</mwc-icon>
                    <div>Profiles</div>
                </a>
            </div>

            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            .pageContainer {
                padding: 20px;
                box-sizing: border-box;
            }

            .bottomTabs {
                display: flex;
                position: fixed;
                bottom: 0;
                width: 100%;
                box-sizing: border-box;
                align-items: center;
                justify-content: space-around;
                background: var(--main-secondary-color);
                color: var(--theme-white-color);
                z-index: 2;
            }

            .bottomTabs .tabItem {
                display: flex;
                flex: 1;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                padding: 0.5rem;
                color: var(--theme-white-color);
                border-top: 4px solid transparent;
                cursor: pointer;
                text-decoration: none;
            }

            .bottomTabs .tabItem.active {
                color: var(--main-primary-color);
                border-top: 4px solid var(--main-primary-color);
            }
        `;
    }
}
